import { VehicleType } from "@_types/VehicleType";
import { api } from ".";

export async function fetchVehicleTypes() {
  const response = await api.get<VehicleType[]>("/vehicleType");

  return response.data;
}